import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m8 14-6 6h9v-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M18.37 3.63 8 14l3 3L21.37 6.63a2.12 2.12 0 1 0-3-3Z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Slice";
const Slice = memo(themed(Icon));
export {
  Slice
};
//# sourceMappingURL=slice.js.map
